import styled from 'styled-components';
import { Card } from 'antd';

export const FormContainer = styled.div`
  padding: 24px;
  background: #f5f5f5;
  min-height: calc(100vh - 64px);

  h1 {
    font-size: 28px;
    font-weight: 600;
    color: #262626;
    margin: 0;
  }
`;

export const FormCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: none;

  .ant-card-head {
    border-bottom: 1px solid #f0f0f0;
  }

  .ant-card-head-title {
    font-weight: 600;
    color: #262626;
  }
`;

export const WorkflowCard = styled(Card)`
  margin-bottom: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: none;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);

  .ant-card-head {
    border-bottom: 1px solid #e0f2fe;
    background: rgba(255, 255, 255, 0.8);
  }

  .ant-card-head-title {
    font-weight: 600;
    color: #262626;
  }
`;

export const EnabledSection = styled.div`
  margin-bottom: 24px;
  transition: all 0.3s ease;

  ${FormCard} {
    border: 2px solid transparent;
    
    &:hover {
      border-color: #1890ff;
      transform: translateY(-1px);
    }
  }
`;

export const DisabledSection = styled.div`
  margin-bottom: 24px;
  
  ${FormCard} {
    background: #fafafa;
    border: 2px dashed #d9d9d9;
    opacity: 0.7;
    
    .ant-card-head {
      background: #f5f5f5;
    }
    
    .ant-card-body {
      padding: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 80px;
    }
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding: 24px 0;
  border-top: 1px solid #f0f0f0;
  margin-top: 24px;
`;